import { useState } from 'react';
import Container from '@mui/material/Container';
import { useTranslation } from 'react-i18next';
import Stack from '@mui/material/Stack';
import Icon from '@mdi/react';
import { mdiChevronDown } from '@mdi/js';
import { useNavigate } from 'react-router-dom';
import { BaseBreadcrumbs, BaseButtonMenu } from '@mgm/common/components/base';
import { PageHelmet, TourIcon, VideoModal } from '../../components';
import { PAGES_ANALYTICS_TITLES } from '../../utils/enums';
import {
  DeleteTeamMember,
  CreateEditMember,
  TeamTour,
  TeamTable,
} from '../../features/team';

import { TListBaseItem } from '../../components/base/BList/type';
import { memberActions } from '../../store/team/slice';
import { TMember } from '../../types';
import { commonActions } from '../../store/common/slice';
import { useAppDispatch, useAppSelector } from '../../hooks/useAppStore';
import { getIsOpenShopifyIdVideo, getMembers } from '../../store/team/selectors';
import { ROUTES } from '../../data';

const TeamPage = () => {
  const { t } = useTranslation(['team', 'commissions', 'common']);
  const members = useAppSelector(getMembers);
  const dispatch = useAppDispatch();
  const navigation = useNavigate();
  const isOpenShopifyIdVideo = useAppSelector(getIsOpenShopifyIdVideo);
  const [runTeamTour, setRunTeamTour] = useState(false);

  const handleTour = (page: string, isRunning: boolean) => {
    if (page === 'team') {
      setRunTeamTour(isRunning);
    }
  };

  const items: Array<TListBaseItem> = [
    {
      name: t('addMany'),
      value: 'bulk',
      isSelected: false,
      action: () => {
        dispatch(memberActions.setActiveBulkStep(0));
        navigation(ROUTES.TEAM_BULK);
      },
    },
    {
      name: t('addOne'),
      value: 'shopify',
      isSelected: false,
      action: () => {
        dispatch(memberActions.setSelectedMember({} as TMember));
        dispatch(commonActions.setIsOpenPagesNav(true));
      },
    },
  ];

  return (
    <PageHelmet title={PAGES_ANALYTICS_TITLES.TEAM}>
      <TeamTour runTour={runTeamTour} handleFinishTour={() => handleTour('team', false)} />
      <Container sx={{ pt: 2, px: { xs: 0, lg: 2 } }} maxWidth={false}>
        <BaseBreadcrumbs
          heading={`${t('members')} (${members?.length || 0})`}
          action={(
            <Stack spacing={2} direction="row" alignItems="center" justifyContent="flex-end">
              <TourIcon handleStartTour={() => handleTour('team', true)} />
              <BaseButtonMenu
                isRemoveBtnHover={false}
                buttonProps={{
                  children: t('addMember'),
                  endIcon: (
                    <Icon path={mdiChevronDown} size={0.8} />
                  ),
                  variant: 'contained',
                }}
                listProps={{
                  items,
                  sx: {
                    width: 'auto',
                  },
                  itemfontsize: 12,
                }}
              />
            </Stack>
          )}
        />
        <TeamTable />
        <CreateEditMember />
        <DeleteTeamMember />
        <VideoModal
          isOpenModal={isOpenShopifyIdVideo}
          setIsOpenModal={(val) => dispatch(memberActions.setIsOpenShopifyIdVideo(val))}
          videoTitle={t('linkShopifyStaffToManageMate', { ns: 'common' })}
          videoLink="https://www.youtube.com/watch?v=zX__AWlhDRU"
        />
      </Container>
    </PageHelmet>
  );
};

export default TeamPage;
